import React from 'react';
import { branch, compose, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { selectIsElementChange } from '../../../store/canvas/selectors'
import { clearIsElementChange } from '../../../store/canvas/actions'
import withCreatePage from 'hocs/extends/withCreatePage'
import withEditPage from 'hocs/extends/withEditPage'
import PageController from './PageController';
import { withCanvas } from 'store/canvas/withPaint'

// const initialMenu = megaMenuData

const initialPage = {
  name: 'Untitled',
};

const CreateOrEditPage = compose(
  lifecycle({
    componentWillReceiveProps(nextProps) {
      if (nextProps.isElementChange) {
        window.onbeforeunload = (e) => (e)
        this.props.router.setRouteLeaveHook(this.props.route, () => (
          'Your changes will be discarded. Are you sure you want to leave this page ?'
        ))
      } else {
        const cancelHook = this.props.router.setRouteLeaveHook(this.props.route, () => (''))
        cancelHook()
        window.onbeforeunload = null;
      }
    },
  }),
  branch(
    (props) => props.params.id,
    compose(
      withCanvas(),
      withEditPage({
        resourceName: 'page',
        getInitialResource: () => ({}),
        getOnFetchSuccess: ({ injectPaint }) => (resource) => injectPaint(resource),
      }),
    ),
    compose(
      withCanvas(),
      withCreatePage({
        resourceName: 'page',
        initialState: initialPage,
        getOnInitialize: (props) => props.initializePaint,
      }),
    ),
  ),
)(PageController);

CreateOrEditPage.propTypes = {};
CreateOrEditPage.defaultProps = {};

const mapStateToProps = (state) => ({
  isElementChange: selectIsElementChange(state),
})

const mapDispatchToProps = (dispatch) => (bindActionCreators({ clearIsElementChange }, dispatch))

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreateOrEditPage));




// WEBPACK FOOTER //
// ./src/pages/CustomPages/children/CreateOrEditPage.js